import { Select, Tag } from "antd";
const tagRender = (props) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color={ 'green' }
      onMouseDown={ onPreventMouseDown }
      closable={ closable }
      onClose={ onClose }
      style={ {
        marginRight: 3,
      } }
    >
      { label }
    </Tag>
  );
};
const BaseSelectWithSearch = (props) => {
  const mergedStyle = {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    height: '48px',
    ...props.style,
  };
  
  return (

    <Select
      style={ mergedStyle }
      placeholder={ props.placeholder }
      allowClear
      { ...props }
      showSearch={ true }
      filterOption={ (input, option) => option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      options={ props.options }
      tagRender={ tagRender }
    />

  )
}

export default BaseSelectWithSearch
